import React, { useEffect, useState } from 'react';
import { Alert, Card, Col, Form, Row, Stack } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toCamelCase } from '../../helper';
import { getSecureItem } from "../../utils/secureStorage";
const Step2 = ({
    error,
    setAddEyeTestConfig,
    addEyeTestConfig,
    view,
    symptomcomment,
    setSymptomcomment = () => { },
}) => {
    const { t } = useTranslation();

    const user = getSecureItem('UserData');
    // Check if "None of the Above" is selected in ALL sections

    const isAllNoneOfTheAboveSelected = () => {
        const isAllNoneSelected =
            symptoms['None of the Above'] !== 'false' &&
            dignosedwith['None of the Above'] !== 'false' &&
            healthConditions['None of the Above'] !== 'false';

        return isAllNoneSelected;
    };

    const requiresSymptomComment = () => {
        console.log('symptoms ++++>', symptoms);
        console.log('dignosedwith ++++> ', dignosedwith);
        console.log('healthConditions +++++> ', healthConditions);

        // If ALL sections have "None of the Above" selected, comment is NOT required
        if (isAllNoneOfTheAboveSelected()) {
            return false;
        }

        // Otherwise, check if any real option is selected
        const symptomcommentrequired =
            hasAnyRealOption(symptoms) ||
            hasAnyRealOption(dignosedwith) ||
            hasAnyRealOption(healthConditions);
        return symptomcommentrequired;
    };
    const checkBoxValues = {
        symptoms: {
            'Frequent Flashes': 'false',
            FrequentFloaters: 'false',
            'Eye redness / pain': 'false',
            'Severe Headhaches': 'false',
            'Double Vision': 'false',
            'Loss of Vision': 'false',
            Dizziness: 'false',
            Photosensible: 'false',
            'None of the Above': 'false',
        },
        dignosedwith: {
            'Amblyopya or Lazy eye': 'false',
            Strabismus: 'false',
            Glaucoma: 'false',
            Cataract: 'false',
            'Macular or Retinal Degeneration': 'false',
            'Retinal Detachment': 'false',
            'Corneal Dystrophy': 'false',
            'None of the Above': 'false',
        },
        healthConditions: {
            Diabetes: 'false',
            Hypertension: 'false',
            'Multiple Sclerosis': 'false',
            'None of the Above': 'false',
        },
    };

    const [loading, setLoading] = useState(true);
    const [symptoms, setSymptoms] = useState(checkBoxValues.symptoms);
    const [dignosedwith, setDignosedwith] = useState(
        checkBoxValues.dignosedwith
    );
    const [healthConditions, setHealthConditions] = useState(
        checkBoxValues.healthConditions
    );
    const [charLimitErrors, setCharLimitErrors] = useState({
        symptomComment: false,
    });
    // const [symptomcomment, setSymptomcomment] = useState(false);

    // Function to check if "None of the Above" is selected for all sections
    //     const isAllNoneOfTheAbove = () =>
    //     {
    //         debugger
    //         // return symptoms['None of the Above'] !== 'false' &&
    //         //        dignosedwith['None of the Above'] !== 'false' &&
    //         //        healthConditions['None of the Above'] !== 'false';

    //         // Check: kisi bhi section me "None of the Above" ke alawa koi option select hua hai?
    //   const hasAnyOtherSymptom = Object.keys(symptoms).some( key => key !== "None of the Above" && symptoms[key] !== "false") ||
    //                              Object.keys(dignosedwith).some(key => key !== "None of the Above" && dignosedwith[key] !== "false" ) ||
    //                             Object.keys(healthConditions).some(key => key !== "None of the Above" && healthConditions[key] !== "false");

    //   console.log(symptoms, "symptoms-----");
    //   console.log(dignosedwith, "dignosedwith-----");
    //   console.log(healthConditions, "healthConditions-----");

    //      return !hasAnyOtherSymptom;
    //    };

    const hasAnyRealOption = (section) => {
        return Object.entries(section).some(
            ([key, value]) => key !== 'None of the Above' && value !== 'false'
        );
    };

    // const requiresSymptomComment = () => {
    //     console.log('symptoms ++++>', symptoms);
    //     console.log('dignosedwith ++++> ', dignosedwith);
    //     console.log('healthConditions +++++> ', healthConditions);
    //     const symptomcommentrequired =
    //         hasAnyRealOption(symptoms) ||
    //         hasAnyRealOption(dignosedwith) ||
    //         hasAnyRealOption(healthConditions);
    //     return symptomcommentrequired;
    // };

    useEffect(() => {
        const symptom = requiresSymptomComment();

        if (symptom) {
            console.log(
                '122 - useEffect - if condition - single condition - symptomcomment +++++++++++++++++++++> ',
                symptomcomment
            );

            if (addEyeTestConfig?.symptomComment === '') {
                console.log(
                    '995  if condition - true statement - symptomcomment +++++++++++++++++++++> ',
                    symptomcomment
                );
                setSymptomcomment(true);
                return;
            } else {
                console.log(
                    '1001  if condition - false statement - symptomcomment +++++++++++++++++++++> ',
                    symptomcomment
                );
                setSymptomcomment(false);
            }
        }
        else { setSymptomcomment(false); }

        console.log(symptom, 'Symtop.............');
    }, [
        addEyeTestConfig.symptoms,
        addEyeTestConfig.healthConditions,
        addEyeTestConfig.dignosedwith,
        addEyeTestConfig?.symptomComment,
    ]);

    useEffect(() => {
        if (loading) {
            Object.keys(checkBoxValues.symptoms).forEach((key) => {
                checkBoxValues.symptoms[key] = addEyeTestConfig.symptoms
                    .toLowerCase()
                    .split(',')
                    .map((item) => item.trim())
                    .includes(key.toLowerCase())
                    ? 'true'
                    : 'false';
            });
            Object.keys(checkBoxValues.dignosedwith).forEach((key) => {
                checkBoxValues.dignosedwith[key] = addEyeTestConfig.dignosedwith
                    .toLowerCase()
                    .split(',')
                    .map((item) => item.trim())
                    .includes(key.toLowerCase())
                    ? 'true'
                    : 'false';
            });
            Object.keys(checkBoxValues.healthConditions).forEach((key) => {
                checkBoxValues.healthConditions[key] =
                    addEyeTestConfig.healthConditions
                        .toLowerCase()
                        .split(',')
                        .map((item) => item.trim())
                        .includes(key.toLowerCase())
                        ? 'true'
                        : 'false';
            });
            setLoading(false);
        }
    }, [loading]);

    const handleChange = (e, stateSetter, prevValues) => {
        let { name, value, checked } = e.target;

        let result;
        if (value === 'None of the Above') {
            result = {
                ...checkBoxValues[name],
                [value]: checked ? value : 'false',
            };
        } else {
            result = {
                ...prevValues,
                [value]: checked ? value : 'false',
                'None of the Above': 'false',
            };
        }
        setAddEyeTestConfig((prev) => {
            return {
                ...prev,
                [name]: Object.entries(result)
                    .map(([, value]) => value)
                    .join(','),
            };
        });
        stateSetter(result);
    };

    // Handle textarea change
    const handleTextareaChange = (e) => {
        const { name, value } = e.target;

        // Check character limit
        if (value.length > 500) {
            setCharLimitErrors((prev) => ({ ...prev, [name]: true }));
            return;
        } else {
            setCharLimitErrors((prev) => ({ ...prev, [name]: false }));
        }

        setAddEyeTestConfig((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <Card>
            <Card.Body className="modal_form">
                <Row>
                    <Col md={`${view == 'add' ? 10 : 12}`}>
                        <Stack
                            direction={`${view !== 'add' ? 'horizontal' : ''}`}
                            className={`${view !== 'add' ? 'eye_test_view' : ''}`}
                            gap={3}
                        >
                            <div className="mb-5">
                                <h6 className="font_semibold">
                                    {t(
                                        'areyoucurrentlyexperiencinganyofthefollowing'
                                    )}
                                    *
                                </h6>
                                {!loading && (
                                    <Stack
                                        direction={`${view == 'add' ? 'horizontal' : ''}`}
                                        gap={3}
                                        className={`${view == 'add' ? 'eye_test_checkboxes' : ''}`}
                                    >
                                        {Object.keys(
                                            checkBoxValues.symptoms
                                        ).map((item, index) => (
                                            <Form.Check
                                                key={index}
                                                type="checkbox"
                                                name="symptoms"
                                                onChange={(e) =>
                                                    handleChange(
                                                        e,
                                                        setSymptoms,
                                                        symptoms
                                                    )
                                                }
                                                checked={
                                                    symptoms[item] !== 'false'
                                                }
                                                value={item}
                                                id={`${item}_symptoms`}
                                                label={t(toCamelCase(item))}
                                            />
                                        ))}

                                        {error?.symptoms && (
                                            <Alert
                                                style={{ width: '100%' }}
                                                variant={'danger'}
                                            >
                                                {t('mustEnterValue')}
                                            </Alert>
                                        )}
                                    </Stack>
                                )}
                            </div>

                            <div className="mb-5">
                                <h6 className="font_semibold">
                                    {t(
                                        'haveYouEverBeenDiagnosedWithAnyOfTheFollowingEyeConditions'
                                    )}
                                    *
                                </h6>
                                {!loading && (
                                    <Stack
                                        direction={`${view == 'add' ? 'horizontal' : ''}`}
                                        gap={3}
                                        className={`${view == 'add' ? 'eye_test_checkboxes' : ''}`}
                                    >
                                        {Object.keys(
                                            checkBoxValues.dignosedwith
                                        ).map((item, index) => (
                                            <Form.Check
                                                key={index}
                                                type="checkbox"
                                                name="dignosedwith"
                                                onChange={(e) =>
                                                    handleChange(
                                                        e,
                                                        setDignosedwith,
                                                        dignosedwith
                                                    )
                                                }
                                                checked={
                                                    dignosedwith[item] !==
                                                    'false'
                                                }
                                                value={item}
                                                id={`${item}_dignosedwith`}
                                                label={t(toCamelCase(item))}
                                            />
                                        ))}
                                        {error?.dignosedwith && (
                                            <Alert
                                                style={{ width: '100%' }}
                                                variant={'danger'}
                                            >
                                                {t('mustEnterValue')}
                                            </Alert>
                                        )}
                                    </Stack>
                                )}
                            </div>

                            <div className="mb-5">
                                <h6 className="font_semibold">
                                    {t(
                                        'doYouSufferFromAnyOfTheFollowingConditions'
                                    )}
                                    *
                                </h6>
                                {!loading && (
                                    <Stack
                                        direction={`${view == 'add' ? 'horizontal' : ''}`}
                                        gap={3}
                                        className={`${view == 'add' ? 'eye_test_checkboxes' : ''}`}
                                    >
                                        {Object.keys(
                                            checkBoxValues.healthConditions
                                        ).map((item, index) => (
                                            <Form.Check
                                                key={index}
                                                type="checkbox"
                                                name="healthConditions"
                                                onChange={(e) =>
                                                    handleChange(
                                                        e,
                                                        setHealthConditions,
                                                        healthConditions
                                                    )
                                                }
                                                checked={
                                                    healthConditions[item] !==
                                                    'false'
                                                }
                                                value={item}
                                                id={`${item}_healthConditions`}
                                                label={t(toCamelCase(item))}
                                            />
                                        ))}
                                        {error?.healthConditions && (
                                            <Alert
                                                style={{ width: '100%' }}
                                                variant={'danger'}
                                            >
                                                {t('mustEnterValue')}
                                            </Alert>
                                        )}
                                    </Stack>
                                )}
                            </div>
                        </Stack>
                    </Col>
                    {user?.userType !== 'PATIENT' && (
                        <Col
                            md={12}
                            className={`${view === 'view' ? 'custom_disabled' : ''}`}
                        >
                            <Form.Group
                                className={`mb-5 ${error?.symptomComment ? 'error_input' : ''
                                    }`}
                            >
                                <Form.Label>
                                    {t('commentsymptoms')}
                                    {requiresSymptomComment() && '*'}
                                </Form.Label>

                                {/* ================= VIEW MODE ================= */}
                                {view === 'view' ? (
                                    <div
                                        className="form-control"
                                        style={{
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            whiteSpace: 'pre-wrap',
                                            backgroundColor: '#f8f9fa',
                                            cursor: 'default',
                                        }}
                                    >
                                        {addEyeTestConfig?.symptomComment || '-'}
                                    </div>
                                ) : (
                                    /* ================= ADD / EDIT MODE ================= */
                                    <Form.Control
                                        as="textarea"
                                        name="symptomComment"
                                        value={addEyeTestConfig?.symptomComment || ''}
                                        onChange={handleTextareaChange}
                                        rows={3}
                                        type="text"
                                        placeholder={t('inputText')}
                                        isInvalid={charLimitErrors.symptomComment}
                                    />
                                )}

                                {/* ================= CHAR COUNT ================= */}
                                <div className="d-flex justify-content-between mt-1">
                                    <Form.Text className="text-muted">
                                        {addEyeTestConfig?.symptomComment?.length || 0}
                                        / 500 caractères
                                    </Form.Text>

                                    {charLimitErrors.symptomComment && (
                                        <Form.Text className="text-danger">
                                            500 caractères maximum autorisés
                                        </Form.Text>
                                    )}
                                </div>

                                {/* ================= VALIDATION ERRORS ================= */}
                                {error?.symptomComment && (
                                    <Form.Control.Feedback type="invalid">
                                        {t('mustEnterValue')}
                                    </Form.Control.Feedback>
                                )}

                                {error?.symcomment && (
                                    <Alert
                                        style={{ width: '100%' }}
                                        variant="danger"
                                    >
                                        {t('commentsymptoms')}
                                    </Alert>
                                )}

                                {view !== 'view' &&
                                    view !== 'edit' &&
                                    symptomcomment && (
                                        <Alert
                                            style={{ width: '100%' }}
                                            variant="danger"
                                        >
                                            {t('errorsymptomrequired')}
                                        </Alert>
                                    )}
                            </Form.Group>
                        </Col>
                    )}
                </Row>
            </Card.Body>
        </Card>
    );
};
export default Step2;
